import toast, { Toaster } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import useFormWithSchema from "../../hooks/useFormWithSchema";
import BackButton from "../../components/button/BackButton";
import { Controller } from "react-hook-form";
import TextInput from "../../components/inputs/TextInput";
import { Button } from "../../components/button";
import ComboboxInput from "../../components/inputs/ComboboxInput";
import {
  addBlacklistVisitorInitialValues,
  API_ERRORS,
  BLACKLIST_TYPES,
  DOC_TYPE_ID,
} from "../../constants/common";
import { useGetDocumentIDTypes } from "../../hooks/common/query";
import { mapToOptions } from "../../lib/functions";
import { useMemo } from "react";
import { APP_ROUTES } from "../../routes";
import { useNavigate } from "react-router-dom";
import { useAddBlacklist } from "../../hooks/visitor/mutation";
import { AddBlacklistVisitorSchema } from "../../schemas/addBlacklistVisitorSchema";

interface FormData {
  blacklistType?: number;
  idType?: number;
  eid?: string | null;
  passportNumber?: string | null;
  visaNumber?: string | null;
  iqama?: string | null;
  companyName?: string;
  nationality?: string;
  reason: string;
}

const AddBlacklistVisitor = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const {
    handleSubmit,
    control,
    formState: { errors },
    watch,
    reset,
  } = useFormWithSchema(AddBlacklistVisitorSchema);

  // const blacklistType = watch("blacklistType");

  // const { data: allNationalities } = useGetAllNationalities();
  const { data: allDocumentIDTypes } = useGetDocumentIDTypes();

  // const { data: allBlacklistTypes } = useGetAllSystemDetailCodesDropdown({
  //   encryptedId: SYSTEM_DETAIL_CODES.BLACKLIST_TYPES,
  // });

  const {
    mutateAsync: BlacklistVisitor,
    isPending: isBlacklistVisitorLoading,
  } = useAddBlacklist();

  // const blacklistTypes = useMemo(
  //   () =>
  //     mapToOptions("s_Desc_E", "s_Desc_A", "n_DetailedCode", allBlacklistTypes),
  //   [allBlacklistTypes]
  // );

  const selectedIdType = watch("idType");

  // const nationalities = useMemo(
  //   () => mapToOptions("name", "name_Ar", "iso3", allNationalities),
  //   [allNationalities]
  // );

  const documentIDTypes = useMemo(
    () =>
      mapToOptions(
        "s_Desc_E",
        "s_Desc_A",
        "n_DetailedCode",
        allDocumentIDTypes
      ),
    [allDocumentIDTypes]
  );

  const onSubmit = async (data: FormData) => {
    try {
      const body = {
        n_blacklistType: BLACKLIST_TYPES.PERSON,

        // ...(data.blacklistType === BLACKLIST_TYPES.PERSON && {
        idType: data.idType,
        // }),
        // ...(data.blacklistType === BLACKLIST_TYPES.PERSON &&
        // data.idType === DOC_TYPE_ID.NATIONAL_ID && {
        S_EmiratesID: data.eid,
        // }),
        // ...(data.blacklistType === BLACKLIST_TYPES.PERSON &&
        // data.idType === DOC_TYPE_ID.PASSPORT && {
        S_PassportNumber: data.passportNumber,
        // }),

        // ...(data.blacklistType === BLACKLIST_TYPES.PERSON &&
        // data.idType === DOC_TYPE_ID.VISA && {
        S_VisaNo: data.visaNumber,
        // }),

        // ...(data.blacklistType === BLACKLIST_TYPES.PERSON &&
        // data.idType === DOC_TYPE_ID.IQAMA && {
        S_Iqama: data.iqama,
        // }),

        // ...(data.blacklistType !== BLACKLIST_TYPES.NATIONALITY && {
        // S_CompanyName: data.companyName,
        // }),

        // ...(data.blacklistType === BLACKLIST_TYPES.NATIONALITY && {
        //   S_Nationality: data.nationality,
        // }),

        S_Reason: data.reason,
      };

      await BlacklistVisitor(body);
      toast.success(t("blacklistedSuccessfully"));

      setTimeout(() => {
        navigate(APP_ROUTES.SEARCH_BLACKLIST_VISITORS);
      }, 700);
    } catch (error: any) {
      const errorCode = Object.keys(error.errors)[0];

      if (errorCode === API_ERRORS.NATIONALITY_ALREADY_BLACKLISTED) {
        toast.error(t("nationalityAlreadyBlacklisted"));
      } else if (errorCode === API_ERRORS.VISITOR_ALREADY_BLACKLISTED) {
        toast.error(t("visitorAlreadyBlacklisted"));
      } else if (errorCode === API_ERRORS.COMPANY_ALREADY_BLACKLISTED) {
        toast.error(t("companyAlreadyBlacklisted"));
      } else {
        toast.error(t("somethingWentWrong"));
      }
    }
  };
 
  const onClear = () => {
    reset(addBlacklistVisitorInitialValues);
  };

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />

      <div className="flex flex-col lg:gap-2">
        <div className="flex flex-col gap-4 md:gap-8">
          <div className="flex items-center gap-1 sm:gap-2 justify-between">
            <h1 className="text-xl md:text-2xl dark:text-white">
              {t("addBlacklistVisitor")}
            </h1>

            <div className="flex items-center gap-2">
              <Button
                type="button"
                onClick={() => navigate(APP_ROUTES.SEARCH_BLACKLIST_VISITORS)}
                className="bg-transparent ring-1 ring-purple-primary text-purple-primary hover:bg-transparent dark:!ring-white dark:text-white"
              >
                {t("searchBlacklistVisitors")}
              </Button>

              <BackButton />
            </div>
          </div>

          <div className="bg-white p-4 rounded-xl flex flex-col gap-3 lg:gap-6 shadow-[0px_1px_5px_0px_rgba(113,112,163,0.3)]">
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="flex flex-col gap-4"
            >
              <div className="flex flex-col gap-2 lg:gap-4">
                {/* <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-4">
                  <Controller
                    name="blacklistType"
                    control={control}
                    render={({ field: { onChange, name, value } }) => {
                      return (
                        <ComboboxInput
                          label={t("blacklistType")}
                          options={blacklistTypes}
                          value={
                            blacklistTypes?.find((item) => item.value === value)
                              ?.labelEn || ""
                          }
                          onChange={onChange}
                          required
                          error={errors?.[name]?.message}
                        />
                      );
                    }}
                  />
                </div> */}

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-4">
                  {/* {blacklistType === BLACKLIST_TYPES.PERSON ? ( */}
                  <>
                    <Controller
                      name="idType"
                      control={control}
                      render={({ field: { name, onChange, value } }) => {
                        return (
                          <ComboboxInput
                            options={documentIDTypes}
                            onChange={(value) =>
                              onChange(value === "" ? null : value)
                            }
                            error={errors?.[name] && t("idTypeRequired")}
                            value={
                              value === DOC_TYPE_ID.NATIONAL_ID
                                ? "National ID"
                                : value === DOC_TYPE_ID.PASSPORT
                                ? "Passport"
                                : ""
                            }
                            label={t("idType")}
                            required
                          />
                        );
                      }}
                    />

                    {selectedIdType === DOC_TYPE_ID.NATIONAL_ID && (
                      <Controller
                        name="eid"
                        control={control}
                        render={({ field: { onChange, name, value } }) => (
                          <TextInput
                            label={t("nationalID")}
                            onChange={onChange}
                            error={errors?.[name]?.message}
                            required
                            value={value || ""}
                          />
                        )}
                      />
                    )}
                    {selectedIdType === DOC_TYPE_ID.PASSPORT && (
                      <Controller
                        name="passportNumber"
                        control={control}
                        render={({ field: { onChange, name, value } }) => (
                          <TextInput
                            label={t("passportNumber")}
                            onChange={onChange}
                            error={errors?.[name]?.message}
                            required
                            value={value || ""}
                          />
                        )}
                      />
                    )}

                    {selectedIdType === DOC_TYPE_ID.IQAMA && (
                      <Controller
                        name="iqama"
                        control={control}
                        render={({ field: { onChange, name, value } }) => (
                          <TextInput
                            label={t("iqama")}
                            onChange={onChange}
                            error={errors?.[name]?.message}
                            required
                            value={value || ""}
                          />
                        )}
                      />
                    )}

                    {selectedIdType === DOC_TYPE_ID.VISA && (
                      <Controller
                        name="visaNumber"
                        control={control}
                        render={({ field: { onChange, name, value } }) => (
                          <TextInput
                            label={t("visaNumber")}
                            onChange={onChange}
                            error={errors?.[name]?.message}
                            required
                            value={value || ""}
                          />
                        )}
                      />
                    )}

                    {/* <Controller
                        name="companyName"
                        control={control}
                        render={({ field: { onChange, name, value } }) => (
                          // <ComboboxInputWithCustomValue
                          //   label={t("companyName")}
                          //   value={value || ""}
                          //   onChange={onChange}
                          //   options={[]}
                          //   error={errors?.[name]?.message}
                          // />

                          <TextInput
                            label={t("companyName")}
                            onChange={onChange}
                            value={value || ""}
                          />
                        )}
                      /> */}
                  </>
                  {/* ) : (
                    <></>
                  )} */}

                  {/* {blacklistType === BLACKLIST_TYPES.COMPANY ? (
                    <Controller
                      name="companyName"
                      control={control}
                      render={({ field: { onChange, name, value } }) => (
                        // <ComboboxInputWithCustomValue
                        //   label={t("companyName")}
                        //   value={value || ""}
                        //   onChange={onChange}
                        //   options={[]}
                        //   required
                        //   error={errors?.[name]?.message}
                        // />

                        <TextInput
                          label={t("companyName")}
                          onChange={onChange}
                          error={errors?.[name]?.message}
                          value={value || ""}
                          required
                        />
                      )}
                    />
                  ) : (
                    <></>
                  )} */}

                  {/* {blacklistType === BLACKLIST_TYPES.NATIONALITY ? (
                    <Controller
                      name="nationality"
                      control={control}
                      render={({ field: { name, onChange, value } }) => {
                        return (
                          <ComboboxInput
                            label={t("nationality")}
                            options={nationalities}
                            onChange={onChange}
                            value={
                              nationalities?.find(
                                (item) => item.value === value
                              )?.labelEn || ""
                            }
                            error={errors?.[name] && t("nationalityRequired")}
                            required
                          />
                        );
                      }}
                    />
                  ) : (
                    <></>
                  )} */}
                </div>

                {/* {blacklistType ? ( */}
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-4">
                  <Controller
                    name="reason"
                    control={control}
                    render={({ field: { onChange, name, value } }) => (
                      <TextInput
                        label={t("reason")}
                        onChange={onChange}
                        error={errors?.[name] && t("reasonRequired")}
                        value={value || ""}
                        required
                      />
                    )}
                  />
                </div>
                {/* ) : (
                  <></>
                )} */}

                <div className="flex items-center gap-2 mt-2">
                  <Button isLoading={isBlacklistVisitorLoading}>
                    {t("save")}
                  </Button>
                  <Button
                    type="button"
                    onClick={onClear}
                    className="bg-transparent ring-1 ring-purple-primary text-purple-primary hover:bg-transparent dark:!ring-white dark:text-white"
                  >
                    {t("clear")}
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddBlacklistVisitor;
